import PropTypes from 'prop-types';

export const infoShape = PropTypes.shape({
  category: PropTypes.string,
  action: PropTypes.string,
  name: PropTypes.string,
  info_title: PropTypes.string,
  info_content: PropTypes.string
});
